import React, { Component } from "react";
import L from "leaflet";
import { withTranslation } from 'react-i18next';

import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import MapComponent from '../Map/Map'

import "bootstrap/dist/css/bootstrap.min.css";
import '../css/ficha_int.css'
import { HOST, API_URL } from '../auxiliar/constants'

class SpecieMapModal extends Component {


    state = {
        loading: true,
        sibicRecords: [],
        easinRecords: []
    }

    componentDidMount() {
        this.fetchInitialRecords()
    }

    async fetchInitialRecords() {

        let sibicRecords = []
        let easinRecords = []

        await fetch('https://eei.sibic.org/API/geo2.php')
            .then(response => response.json())
            .then(data => {
                sibicRecords = data.records.map(record => {
                    return {
                        lng: parseFloat(record.longitude),
                        lat: parseFloat(record.latitude),
                        type: 'SIBIC',
                        recId: record.records_id,
                        specId: record.species_id,
                        heat: [parseFloat(record.latitude), parseFloat(record.longitude), "100"]
                    }
                })
            })

        await fetch(`${HOST}${API_URL}/?function=getRecords`)
            .then(response => response.json())
            .then(data => {
                easinRecords = data.records.map(record => {
                    let rect = L.rectangle(JSON.parse(record.polygon), {})
                    let center = rect.getBounds().getCenter()
                    return {
                        lng: center.lng,
                        lat: center.lat,
                        type: 'EASIN',
                        recId: record.recordId,
                        specId: record.speciesId,
                        heat: [center.lat, center.lng, "100"]
                    }
                })
            })

        this.setState({
            sibicRecords: sibicRecords.filter(sR => sR.specId === this.props.sibicId),
            easinRecords: this.props.easinId ? easinRecords.filter(eR => eR.specId === this.props.easinId) : [],
            loading: false
        })
    }


    render() {

        const markers = [].concat(this.state.sibicRecords).concat(this.state.easinRecords)

        return (

            <Modal dialogClassName="specie-map-modal" show={true} onHide={this.props.onClose}>
                <Modal.Header closeButton />
                <Modal.Body>
                    {
                        this.state.loading ?
                        <SpecieSpinner /> :
                        <MapComponent tileType={'HEAT'} mapType={'MAP'} markers={markers} loading={false} />
                    }
                </Modal.Body>
            </Modal>



        );
    }
}

// export default Species;
export default withTranslation()(SpecieMapModal);

const SpecieSpinner = props => (
    <div
        className="my_spinner"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 'calc(90vh - 57px)',
            backgroundColor: '#fff'
        }}
    >
        <div>
            <Spinner className="spin m-3" animation="grow" variant="success" />
            <Spinner className="spin m-3" animation="grow" variant="info" />
            <Spinner className="spin m-3" animation="grow" variant="success" />
        </div>
    </div>
)
